import { useState } from "react";
import { H2RHeading } from "../../imports";

export default function ThemeSection({
	name,
	icon = {},
	colour = "bg-gray-800",
	children,
}) {
	const [opened, setOpened] = useState(false);

	let iconSVG;
	let iconColour = "bg-gray-700";

	switch (icon) {
		case "font":
			iconSVG = (
				<path
					d="M11.996 31l1.2-3.587h5.469L19.872 31h2.813l-5.128-14.546h-3.253L9.184 31h2.812zm1.91-5.703l1.968-5.86h.113l1.968 5.86h-4.049zM24.601 31h2.528v-1.719h.15c.404.796 1.25 1.91 3.124 1.91 2.571 0 4.496-2.038 4.496-5.631 0-3.637-1.982-5.611-4.503-5.611-1.925 0-2.727 1.157-3.118 1.946h-.106v-5.44H24.6V31zm2.521-5.454c0-2.117.91-3.488 2.564-3.488 1.712 0 2.592 1.456 2.592 3.488 0 2.045-.895 3.536-2.592 3.536-1.64 0-2.564-1.42-2.564-3.537zm14.721 5.667c2.742 0 4.489-1.626 4.673-3.942H44.06c-.22 1.172-1.065 1.847-2.194 1.847-1.606 0-2.643-1.342-2.643-3.572 0-2.202 1.059-3.523 2.642-3.523 1.236 0 1.996.795 2.195 1.846h2.458c-.178-2.365-2.025-3.92-4.688-3.92-3.196 0-5.213 2.308-5.213 5.64 0 3.302 1.967 5.624 5.227 5.624z"
					fill="currentColor"
				/>
			);
			break;
		case "h1":
			iconSVG = (
				<path
					d="M17.189 31h2.634v-6.179h6.74V31h2.643V16.454h-2.642v6.158h-6.74v-6.157h-2.635V31zm20.657-14.546h-2.508l-3.615 2.323v2.415l3.402-2.174h.086V31h2.635V16.454z"
					fill="currentColor"
				/>
			);
			break;
		case "h2":
			iconSVG = (
				<path
					d="M18.226 29h2.108v-4.943h5.392V29h2.114V17.364h-2.114v4.926h-5.392v-4.926h-2.108V29zm11.793 0h7.977v-1.761h-5.068v-.08l2.005-2.04c2.262-2.17 2.887-3.227 2.887-4.54 0-1.948-1.586-3.375-3.926-3.375-2.307 0-3.944 1.432-3.944 3.643h2.006c0-1.188.75-1.932 1.91-1.932 1.107 0 1.93.676 1.93 1.773 0 .971-.59 1.664-1.738 2.829l-4.04 3.96V29z"
					fill="currentColor"
				/>
			);
			break;
		case "background":
			iconSVG = (
				<rect x="14" y="18" width="28" height="12" rx="3" fill="currentColor" />
			);
			break;
		case "border":
			iconSVG = (
				<rect
					x="13.5"
					y="17.5"
					width="29"
					height="13"
					rx="3.5"
					stroke="currentColor"
					strokeWidth="3"
				/>
			);
			break;
		case "position":
			iconSVG = (
				<path
					d="M37.333 33.333h-4.666m-14-14v-4.666 4.666zm0-4.666h4.666-4.666zm0 0L24.5 20.5l-5.833-5.834zm18.666 4.666v-4.666 4.666zm0-4.666h-4.666 4.666zm0 0L31.5 20.5l5.833-5.834zm-18.666 14v4.666-4.666zm0 4.666h4.666-4.666zm0 0L24.5 27.5l-5.833 5.833zm18.666 0L31.5 27.5l5.833 5.833zm0 0v-4.666 4.666z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			);
			break;
		case "transition":
			iconSVG = (
				<path
					d="M19.333 29.417l4.334-4.334m0-6.5h13-13zm13 0l-4.334-4.333 4.334 4.333zm0 0l-4.334 4.334 4.334-4.334zm-4.334 10.834h-13 13zm-13 0l4.334 4.333-4.334-4.333z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			);
			break;

		case "css":
			iconSVG = (
				<path
					d="M23.833 29.5a3.333 3.333 0 0 1-3.333-3.333v-10a1.666 1.666 0 0 1 1.667-1.667H25.5a1.666 1.666 0 0 1 1.667 1.667v10c0 .884-.352 1.732-.977 2.357m-2.357.976c.884 0 1.732-.351 2.357-.976m-2.357.976h10a1.666 1.666 0 0 0 1.667-1.667V24.5a1.666 1.666 0 0 0-1.667-1.667h-1.952m-5.69 5.69 7.07-7.07a1.667 1.667 0 0 0 0-2.357l-2.357-2.358a1.667 1.667 0 0 0-2.357 0l-1.38 1.381m-3.334 8.048h.009"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			);
			break;
		case "options":
			iconSVG = (
				<path
					d="M33 25.667v-8.334M28 19v-1.666V19Zm0 0a1.667 1.667 0 0 0 0 3.334V19Zm0 0a1.667 1.667 0 0 1 0 3.334V19Zm-5 10a1.666 1.666 0 1 0 0-3.333V29Zm0 0a1.667 1.667 0 0 1 0-3.333V29Zm0 0v1.667V29Zm0-3.333v-8.334 8.334Zm5-3.334v8.334-8.334ZM33 29a1.666 1.666 0 1 0 0-3.333V29Zm0 0a1.667 1.667 0 0 1 0-3.333V29Zm0 0v1.667V29Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			);
			break;

		default:
			iconSVG = icon.icon;
			iconColour = icon.iconColour;
			break;
	}

	return (
		<>
			<div className={`flex flex-col rounded ${colour}`}>
				<button
					className={`px-2 py-1 flex items-center space-x-2 text-left rounded focus:outline-none focus:ring ring-gray-700 border-gray-700
							${opened && "border-b-2"}
					`}
					onClick={() => {
						return setOpened(!opened);
					}}
				>
					<span className={`transform scale-75 rounded w-14 ${iconColour}`}>
						<svg
							width="56"
							height="48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							{iconSVG}
						</svg>
					</span>
					<H2RHeading type="h5">{name}</H2RHeading>
				</button>
				{opened && (
					<div className="bg-gray-800 px-4 pb-4 flex flex-col space-y-4">
						{children}
					</div>
				)}
			</div>
		</>
	);
}
